<mnc-shared-services></mnc-shared-services>

@if (initComplete) {
  <router-outlet/>
}
